module.exports = __webpack_public_path__ + "img/2017国药会.78e7e882.jpg";